export default __webpack_public_path__ + "fbd0b3d383830989ef480f8dc0a05344.svg";